import React, { useEffect, useState } from 'react';
import { googleRequest, googleError } from '../../lib/directGoogle';
import SocialAuthButtons from '../auth/SocialAuthButtons';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

export default function LoginMethodsCard() {
  const [methods, setMethods] = useState(null);
  const [error, setError] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    let alive = true;
    googleRequest('/methods', undefined, 'GET').then(r => { if (alive) setMethods(r); }).catch(e => { if (alive) setError(googleError(e)); });
    return () => { alive = false; };
  }, []);
  return <section className="rounded-xl border border-border bg-card p-6 space-y-4">
    <h2 className="font-heading text-lg font-semibold">Inloggningsmetoder</h2>
    {error && <p role="alert" className="text-sm text-red-500">{error}</p>}
    {methods && <>
      <p className="text-sm">Lösenord: {methods.password ? 'Aktivt' : 'Inte aktivt'}</p>
      <p className="text-sm">Google: {methods.providers.includes('google') ? 'Kopplat' : 'Inte kopplat'}</p>
      {methods.legacy_google && !methods.providers.includes('google') && <p className="text-sm text-muted-foreground">Koppla Google på nytt för att använda den uppdaterade inloggningen. Ditt Trainnova-konto och din historik behålls.</p>}
      {!methods.providers.includes('google') ? <SocialAuthButtons mode="link" next="/settings" label="Koppla Google" /> :
        <Button variant="outline" onClick={() => setConfirm(true)}>Koppla bort Google</Button>}
      {confirm && <div className="space-y-3">
        <p className="text-sm">Bekräfta med ditt lösenord. Du måste också ha loggat in under de senaste 15 minuterna.</p>
        <Input type="password" autoComplete="current-password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Lösenord" />
        <Button disabled={busy || !password} onClick={async () => {
          setBusy(true); setError('');
          try { setMethods(await googleRequest('/google', { password }, 'DELETE')); setConfirm(false); setPassword(''); }
          catch (e) { setError(googleError(e)); }
          finally { setBusy(false); }
        }}>Bekräfta bortkoppling</Button>
        <Button variant="ghost" onClick={() => { setConfirm(false); setPassword(''); }}>Avbryt</Button>
      </div>}
    </>}
  </section>;
}
export { LoginMethodsCard };
